import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import WidgetCard from "./WidgetCard";

export default function WeatherWidget() {
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id: projectId } = useParams();

  useEffect(() => {
    if (!projectId) return;

    axios
      .get(`/api/weather/${projectId}/`)
      .then((res) => setWeather(res.data || null))
      .catch((err) => console.error("❌ 날씨 데이터 로드 실패:", err))
      .finally(() => setLoading(false));
  }, [projectId]);

  if (loading) {
    return (
      <WidgetCard title="🌦️ 오늘의 날씨">
        <div className="text-sm text-gray-500 text-center">
          🌤️ 날씨 정보를 불러오는 중...
        </div>
      </WidgetCard>
    );
  }

  if (!weather || !weather.forecast?.length) {
    return (
      <WidgetCard title="오늘의 날씨">
        <div className="text-sm text-gray-500 text-center">
          날씨 데이터가 없습니다.
        </div>
      </WidgetCard>
    );
  }

  const forecast = weather.forecast;

  const getWeatherIcon = (PTY, SKY) => {
    if (PTY === 0) {
      switch (SKY) {
        case 1:
          return "☀️";
        case 3:
          return "🌤️";
        case 4:
          return "☁️";
        default:
          return "☀️";
      }
    } else {
      switch (PTY) {
        case 1:
          return "🌧️";
        case 2:
          return "🌨️🌧️";
        case 3:
          return "❄️";
        case 4:
          return "🌦️";
        default:
          return "☁️";
      }
    }
  };

  const getWeatherText = (PTY, SKY) => {
    if (PTY === 0) {
      switch (SKY) {
        case 1:
          return "맑음";
        case 3:
          return "구름 많음";
        case 4:
          return "흐림";
        default:
          return "맑음";
      }
    } else {
      switch (PTY) {
        case 1:
          return "비";
        case 2:
          return "비/눈";
        case 3:
          return "눈";
        case 4:
          return "소나기";
        default:
          return "흐림";
      }
    }
  };

  return (
    <WidgetCard title="오늘의 날씨">

      {/* 주소 및 최고 / 최저 */}
      <div className="flex items-center justify-between mb-3">
        {/* 현장 주소 (2줄 구성) */}
        <div className="flex flex-col min-w-0 pr-4">
          <div className="text-xs text-slate-600 font-semibold mt-0.5" title={weather.address}>
            {weather.address}
          </div>
          <div className="  text-[10px] text-slate-400 truncate">
            날씨 정보
          </div>
        </div>

        {/* 최고 / 최저 */}
        <div className="flex flex-col w-[80px] items-end shrink-0">
          <div className="flex justify-between w-full text-xs text-slate-600">
            <span>최고</span>
            <span className="text-red-500 font-semibold ml-2">
              {weather.max_temp ?? "-"}°C
            </span>
          </div>
          <div className="flex justify-between w-full text-xs mt-1 text-slate-600">
            <span>최저</span>
            <span className="text-blue-500 font-semibold ml-2">
              {weather.min_temp ?? "-"}°C
            </span>
          </div>
        </div>
      </div>

      {/* 3시간 forecast */}
      <div className="grid grid-cols-3 gap-3 ">
        {forecast.slice(0, 3).map((entry, idx) => (
          <div
            key={idx}
            className="bg-slate-50 border rounded-lg p-3 text-center flex flex-col items-center justify-center"
          >
            <div className="text-3xl mb-1">
              {getWeatherIcon(entry.values.PTY, entry.values.SKY)}
            </div>
            <div className="text-xs text-gray-500">{entry.time}</div>
            <div className="text-sm font-medium text-gray-700">
              {getWeatherText(entry.values.PTY, entry.values.SKY)}
            </div>
            <div className="text-xs text-gray-500">{entry.values.TMP}°C</div>
            <div className="text-[10px] text-blue-500">
              강수 {entry.values.POP}% / {entry.values.PCP}mm
            </div>
          </div>
        ))}
      </div>

    </WidgetCard>
  );
}
